<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户">
          <el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称"></el-input>
        </el-form-item>
        <el-form-item label="推荐人">
          <el-input v-model="formInline.agent_id" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick1">添加会员</el-button>
      <div class="operaction" style="display: flex;padding-top: 15px;">
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="ChangeGrade">批量修改等级</el-button>
        </div>
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchForbidden">批量封禁</el-button>
        </div>
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchRelieve">批量解封</el-button>
        </div>

        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchExport">批量导出</el-button>
        </div>

        <!-- <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchExportAll">导出全部</el-button>
        </div> -->
        <!-- <div class="common-level-rail" style="margin-right:20px;">
            <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="onimport" :show-file-list="false">
              <el-button size="small" icon="el-icon-upload"   type="primary">导入旧用户</el-button>
            </el-upload>
          </div> -->
      </div>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="user_id" label="ID" width="80">

          </el-table-column>
          <el-table-column prop="nickName" label="昵称" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.nickName }}</p>

            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">

              <p>{{ scope.row.mobile }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="is_forbidden" label="状态" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.is_forbidden==0">
                <p>启用</p>
              </div>
              <div v-if="scope.row.is_forbidden==1">
                <p>禁用</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="avatarUrl" label="微信头像">
            <template slot-scope="scope">
              <div v-if="scope.row.avatarUrl">
                <img :src="scope.row.avatarUrl" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="gender" label="性别">
            <template slot-scope="scope">
              {{ scope.row.gender | convertSex }}
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="会员等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade_id == 0">无等级</span>
              <span v-else>{{ scope.row.grade ? scope.row.grade.name : '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="销售总监">
            <template slot-scope="scope">
              <span v-if="scope.row.sales_director == 0">否</span>
              <span v-else>是</span>
            </template>
          </el-table-column>
          <el-table-column prop="down_agent_num" label="伞下代理"></el-table-column>
          <el-table-column prop="balance" :label="getAppinfo('balance_text')"></el-table-column>
          <el-table-column prop="points" label="货款"></el-table-column>
          <!--<el-table-column prop="welfare" :label="getAppinfo('welfare_text')"></el-table-column>-->
          <el-table-column prop="money" label="可提现佣金"></el-table-column>

          <!--<el-table-column prop="country" label="国家"></el-table-column>
          <el-table-column prop="province" label="省份"></el-table-column>
          <el-table-column prop="city" label="城市"></el-table-column>-->

          <!-- <el-table-column prop="province_name" label="省"></el-table-column>
          <el-table-column prop="city_name" label="市"></el-table-column>
          <el-table-column prop="region_name" label="区"></el-table-column> -->
          <el-table-column prop="" label="推荐人" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.referee_id == 0">无</span>
              <span v-else @click="viewUser(scope.row.referee_id)">{{ scope.row.referee_id>0 && scope.row.agent ? scope.row.agent.nickName : '' }}（ID: {{scope.row.referee_id}}）</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="粉丝">
            <template slot-scope="scope">
              <span @click="viewFirstUser(scope.row.user_id)">{{scope.row.first_num}} 人</span>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值</el-button>
              <el-button @click="editAdd(scope.row)" type="text" size="small" v-auth="'/user/user/editAdd'">编辑</el-button>
              <!--              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">编辑会员</el-button>-->
              <a :href="'/h5/#/pages/login/weblogin?app_id=' + app_id + '&user_id='+scope.row.user_id+'&change_secret='+scope.row.change_secret" target="_blank">切换</a>
              <el-button @click="relation(scope.row)" type="text" size="small" v-auth="'/user/user/relation'">关系</el-button>

              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="curPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'add')"></Recharge>

    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'edit')"></Grade>

    <Edit v-if="open_kmd" :open_add="open_kmd" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'kmd')"></Edit>

    <Relation v-if="open_relation" :open_add="open_relation" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'relation')"></Relation>

    <!-- 添加客户 -->
    <Add :open="open_add1" :gradeList="gradeList" @close="closeAdd"></Add>
    <!-- 批量修改等级 -->
    <Changegrade :open="open_changegrade" :gradeList="gradeList" :user_ids="select_list" @close="closeChangeggrade"></Changegrade>

  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import Grade from './dialog/Grade.vue';
import Recharge from './dialog/Recharge.vue';
import Edit from './dialog/Edit.vue';
import Add from './dialog/Add.vue';
import Changegrade from './dialog/Changegrade.vue';
import Relation from './dialog/Relation.vue';
import store from '@/store/'
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Grade,
    Recharge,
    Edit,
    Add,
    Changegrade,
    Relation
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        grade_id: '',
        reg_date: '',
        agent_id: '',
      },
      /*是否打开添加弹窗*/
      open_add: false,
      open_add1: false,
      /*是否打开批量修改等级弹窗*/
      open_changegrade: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      open_kmd: false,
      open_relation: false,
      /*当前编辑的对象*/
      userModel: {
        // 会员到期时间设置
        expire_date_text: '',
      },
      /*等级*/
      gradeList: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的会员列表*/
      select_list: [],
      app_id: 10001,
    };
  },
  created() {
    this.getBaseInfo()
    /*获取列表*/
    this.getTableList()
  },

  methods: {
    // 获取基础信息,获取app_id,跳转路由需要
    async getBaseInfo() {
      let res = await store.dispatch('common/getBaseInfo')
      this.app_id = res.app_id
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase();
      const isEXCEL = (fileType === 'xlsx' || fileType === 'xls');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

      onimport(param){
        let self = this;
        self.$confirm('是否导入旧成员', '提示', {
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在上传,请等待',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let formData = new FormData();
          formData.append('iFile', param.file);

          UserApi.importOldUsers(formData)
            .then(response => {
              loading.close();
              if(response.code == 1){
                self.getTableList();
                self.$message({
                message: response.msg,
                type: 'success'
              });
              }else{
                self.$message({
                message: response.msg,
                type: 'error'
              });
              }


            })
            .catch(response => {
              loading.close();
              self.$message({
                message: '导入失败',
                type: 'warning'
              });
            });
        });
    },
    /*获取列表*/
    getTableList() {
      let self = this
      self.loading = true
      let Params = self.formInline
      Params.page = self.curPage
      Params.list_rows = self.pageSize
      UserApi.userlist(Params, true)
        .then(data => {
          self.loading = false
          self.tableData = data.data.list.data
          self.totalDataNumber = data.data.list.total
          self.gradeList = data.data.grade
        })
        .catch(error => {
          self.loading = false
        });
    },

    viewUser(user_id){
      this.curPage = 1;;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = user_id;
      this.formInline.agent_id = '';
      this.getTableList();
    },

    viewFirstUser(user_id){
      this.curPage = 1;;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = '';
      this.formInline.agent_id = user_id;
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      let self = this
      self.curPage = 1
      self.getTableList()
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },

    /*打开添加客户*/
    addClick1() {
      this.open_add1 = true;
    },
    /*打开批量修改等级*/
    ChangeGrade() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择修改等级的会员',
          type: 'error'
        });
      } else {
        this.open_changegrade = true;
        this.select_list = user_ids;
      }

    },

    /*关闭添加*/
    closeAdd(e) {
      this.open_add1 = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },
    /*关闭批量修改等级*/
    closeChangeggrade(e) {
      this.open_changegrade = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },

    /* 编辑会员信息 */
    editAdd(item) {
      this.userModel = item;
      this.open_kmd = true;
    },
    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
    /*选择会员*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    /* 修改会员关系 */
    relation(item) {
      this.userModel = item;
      this.open_relation = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'kmd') {
        this.open_kmd = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'relation') {
        this.open_relation = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true
          UserApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false
              if (data.code == 1) {
                self.$message({
                  message: '会员删除成功',
                  type: 'success'
                });
                self.getTableList()
              } else {
                self.loading = false
              }
            })
            .catch(error => {
              self.loading = false
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    /*批量禁用用戶*/
    batchForbidden() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择要禁用的用户',
          type: 'error'
        });
      } else {
        UserApi.UserForbidden({
          user_ids: user_ids
        }).then(data => {
          this.$message({
            message: '批量禁用用户成功',
            type: 'success'
          });
          this.getTableList();
        });
      }
    },
    /*批量解封用戶*/
    batchRelieve() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择要禁解封的用户',
          type: 'error'
        });
      } else {
        UserApi.batchRelieve({
          user_ids: user_ids
        }).then(data => {
          this.$message({
            message: '批量解封用户成功',
            type: 'success'
          });
          this.getTableList();
        });
      }

    },
    batchExportAll(){//导出全部
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/product.product/exportUser?' +
      qs.stringify(parmasa)+'&user_ids='+""+"&atype=all";

    },
    batchExport(){//批量导出
        // 勾选需要导出的数据
        let user_ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      console.log("user_ids",user_ids)
      if(user_ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUser?' +
        qs.stringify(parmasa)+'&user_ids='+user_ids+"&atype=cond";

      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }


    },

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue